module.exports = __webpack_public_path__ + "img/logo-rideforgood-400x139.01db991d.png";